export enum CAROUSEL_TYPE {
  HORIZONTAL,
  VERTICAL,
}

export enum NAV_BUTTON {
  NEXT,
  PREV,
}

export enum ACTIONS {
  SET_DIMENSIONS,
  SET_POS,
  SET_SLIDE,
  SET_NUMBER_SLIDES,
  SLIDE_NEXT,
  SLIDE_PREV,
  RESET,
}
